/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Keys_Reveal_WarningInputs */

const vi_api_keys_reveal_warning = /** @type {(inputs: Api_Keys_Reveal_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đây là lần DUY NHẤT khóa được hiển thị. Hãy sao chép và lưu lại ngay — sau khi đóng, bạn sẽ không xem lại được.`)
};

/**

* @param {Api_Keys_Reveal_WarningInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const api_keys_reveal_warning = /** @type {((inputs?: Api_Keys_Reveal_WarningInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Keys_Reveal_WarningInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_api_keys_reveal_warning(inputs)
});